import React, { useState, useEffect, useRef } from "react";
import { ApiService } from "../services";
import styled from "styled-components";
import { Search, Close, KeyboardArrowDown } from "@material-ui/icons";
import { useDetectOutsideClick } from "../useDetectOutsideClick";
import useDebounce from "../useDebounce";

const LI = styled.li`
  padding: 6px 8px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #FC4F56;
    color: #fff;
  }
`;

const Input = styled.input`
  width: 82%;
  /* min-width: 350px; */
  max-width: 450px;
  margin: 5px 0 0;
  height: 30px;
  background: transparent;
  border: 0px;
  outline: 0;
  box-shadow: none;
  color: #777;
  padding-left: 10px;
`;
export const CustomerFilter = ({
  value,
  handleCustomerChange,
  handleBlur,
  handleFocus,
  hideSelectedVal,
  placeholder,
  style,
}) => {
  const [searchWord, setSearchWord] = useState("");
  const debouncedSearchTerm = useDebounce(searchWord, 500);
  const wrapperSRef = useRef(null);
  const [showFilterList, setShowFilterList] = useDetectOutsideClick(
    wrapperSRef,
    false
  );
  const [selectedTitle, setSelectedTitle] = useState("");
  const [customersFilterList, setCustomers] = useState([]);

  useEffect(() => {
    var hitUrl = "customers?per_page=30&search=" + searchWord;
    ApiService({ method: "GET", route: hitUrl })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          setCustomers(response.data.data.data);
          response.data.data.data.map((values) => {
            if (values.id === value) {
              setSelectedTitle(values.title);
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    let selectedIndex = customersFilterList.findIndex((c) => c.id == value);
    console.log(selectedIndex);
    if (selectedIndex > -1) {
      console.log(customersFilterList[selectedIndex]);

      setSelectedTitle(customersFilterList[selectedIndex]?.title);
    } else {
      setSelectedTitle("");
    }
  }, [value]);

  return (
    <div
      ref={wrapperSRef}
      style={Object.assign(
        {},
        {
          width: "212px",
          display: "inline-block",
          position: "relative",
        },
        style
      )}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid rgb(226, 226, 226)",
          height: hideSelectedVal ? "36px" : "40px",
          fontSize: hideSelectedVal ? "0.9rem" : "0.97rem",
          color: hideSelectedVal ? "#333" : "#555",
          boxSizing: "border-box",
          padding: hideSelectedVal ? "8px 10px" : "10px 5px 10px 10px",
          fontFamily: "sans-serif",
          fontWeight: "500",
        }}
        onClick={() => {
          setShowFilterList(true);
          setSearchWord("");
        }}
      >
        {selectedTitle && !hideSelectedVal ? (
          <span
            style={{
              width: "calc(100% - 40px)",
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              height: "20px",
              verticalAlign: "top",
            }}
          >
            {selectedTitle}
          </span>
        ) : (
          <span style={{ color: hideSelectedVal ? "#757575" : "#555" }}>
            {placeholder || "All Customers"}
          </span>
        )}
        <KeyboardArrowDown
          style={{
            float: "right",
            fontSize: "19px",
            color: "#555",
          }}
        />
        {selectedTitle && !hideSelectedVal ? (
          <Close
            fontSize="small"
            style={{
              float: "right",
              fontSize: "18px",
              color: "#777",
              cursor: "pointer",
            }}
            onClick={() => {
              handleCustomerChange();
              setSelectedTitle();
            }}
          />
        ) : (
          ""
        )}
      </div>
      {showFilterList === true ? (
        <div
          style={{
            background: "#fff",
            position: "absolute",
            zIndex: "9",
            width: "200px",
            padding: "0 5px 5px",
            border: "1px solid rgb(226, 226, 226)",
          }}
        >
          <React.Fragment>
            <Input
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
              onBlur={handleBlur}
              onFocus={handleFocus}
              placeholder="Search.."
            />
            <Search
              fontSize="small"
              style={{
                verticalAlign: "middle",
                fontSize: "22px",
                color: "#ccc",
              }}
            />
          </React.Fragment>
          <ul
            style={{
              listStyleType: "none",
              padding: "5px 0",
              margin: "0",
              borderTop: "1px solid #e2e2e2",
              height: "220px",
              overflow: "auto",
            }}
          >
            {customersFilterList.map((c, i) => {
              return (
                <LI
                  key={i}
                  onClick={() => {
                    setSelectedTitle(c.title);
                    setShowFilterList(false);
                    handleCustomerChange(c.id, c);
                  }}
                >
                  {c.title}
                </LI>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
